module.exports = __webpack_public_path__ + "img/room.d59da5ca.png";